export default function pendantPayment({ store }) {
  if (store.getters['class/isPendingPayment']) {
    store.$router.push(`/config/payment/${localStorage.classId}?pendingPayment`)
  }
}
